// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"03ed1cf5","239":"aa69ce9f","455":"ef65cc11"}[chunkId] + ".chunk.js";
};